module.exports = __webpack_public_path__ + "img/proximanova-regular-webfont.120d29c0.svg";